/**
 * 1.3.1 portal strings, stream Q2 (reminders and expiry): the reminder email (email.portal_reminder.*, placeholders
 * PORTAL_EMAIL_PLACEHOLDERS.portal_reminder) and what the portal shows of an expired delivery. Q2's file; step 0
 * wrote the first texts so that every email kind has one (Q2 may reword them).
 */
export const EXTRAS_Q2_STRINGS = {
  'email.portal_reminder.subject': 'Reminder: {title} is due {due}',
  'email.portal_reminder.body': 'Hello {name},\n\nThis is a reminder that the delivery of {title} ({assetCode}) on {portalName} is due {due}.\n\nUpload it here: {link}',
  'reminders.expired': 'This delivery expired on {date}. Contact your PRISM contact if you still need to deliver it.',
} as const;
